import './App.css';
import React, { Component } from 'react';
const { encode } = require('hex-encode-decode')
var hex64 = require('hex64');
var { default: srtParser2 } = require("srt-parser-2");

export default class App extends Component {

  addZeroInHex(str){
    let joy = str.match(/.{1,2}/g);
    return '00' + joy.join('00');
  }
  
  encodeContent (str) {
    let hexPrefix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
    let hexAddon = '0022002C0022006D0054007200610063006B0069006E00670022003A007B0022006D0050006100720061006D00560061006C0075006500730022003A005B005B0030002E0030002C0030002E0030005D005D007D002C0022006D005400730075006D00690022003A007B0022006D0050006100720061006D00560061006C0075006500730022003A005B005B0030002E0030002C0030002E0030005D005D007D002C0022006D0055006E006400650072006C0069006E00650022003A006E0075006C006C007D002C0022006D005400610062005700690064007400680022003A003400300030002E0030002C0022006D0056006500720074006900630061006C0041006C00690067006E006D0065006E00740022003A0030002E0030002C0022006D005700690064007400680022003A0030002E0030007D002C0022006D005500730065004C0065006700610063007900540065007800740042006F00780022003A00660061006C00730065002C0022006D00560065007200730069006F006E0022003A0031002E0030007D00';
    let hexa = encode(str);
    //console.log(hexa);
    let hexWithZero = this.addZeroInHex(hexa);
    let hexFinal = hexPrefix + hexWithZero + hexAddon;
    
    return hex64.encode(hexFinal);
  }

  processTime(str){
    const time = str.split(":");
    let hour = Number(time[0]) * 3600000;
    let minute = Number(time[1]) * 60000;
    let second = Number(String(time[2]).replace(',',''));
    let sum = hour + minute + second;
    return Math.round(sum/40);
  }

  convertSRTtoXML(filename,content){
    var parser = new srtParser2();
    let subtitles = parser.fromSrt(content);
    let xmlContent = '';
    filename = filename.replace('.srt','');
    for (var i = 0; i < subtitles.length; i++){
      var obj = subtitles[i];
      let startTime = '0';
      let endTime = '0';
      let text = '';
      for (var key in obj){
        var value = obj[key];
        if (key === 'startTime'){
          startTime = value;
        } else if (key === 'endTime'){
          endTime = value;
        } else if (key === 'text') {
          text = value;
        }
      }
      let xmlSubPrefix1 = `<clipitem id="clipitem-`;
      let xmlSubPrefix2 = `"><masterclipid>masterclip-`;
      let xmlSubPrefix3 = `</masterclipid><name>Graphic</name><enabled>true</enabled><rate><timebase>25</timebase><ntsc>false</ntsc></rate><start>`;
      let xmlSubPrefix4 = `</start><end>`;
      let xmlSubPrefix5 = `</end><alphatype>none</alphatype><pixelaspectratio>square</pixelaspectratio><anamorphic>false</anamorphic><file id="file-`;
      let xmlSubPrefix6 = `"><name>Graphic</name><mediaSource>GraphicAndType</mediaSource><media><video><samplecharacteristics><width>1920</width><height>1080</height><anamorphic>false</anamorphic><pixelaspectratio>square</pixelaspectratio><fielddominance>none</fielddominance></samplecharacteristics></video></media></file><filter><effect><name>`;
      let xmlSubPrefix7 = `</name><effectid>GraphicAndType</effectid><effectcategory>graphic</effectcategory><effecttype>filter</effecttype><pproBypass>false</pproBypass><parameter authoringApp="PremierePro"><parameterid>1</parameterid><name>Source Text</name><value>`;
      let xmlSubPrefix8 = `</value></parameter><parameter authoringApp="PremierePro"><parameterid>3</parameterid><name>Position</name><IsTimeVarying>false</IsTimeVarying><value>0,0.5:0.8240740740740741,0,0,0,0,0,0,0,0,0,0,0,0</value></parameter></effect></filter></clipitem>`;
      let xmlSubFinal = xmlSubPrefix1 + i + xmlSubPrefix2 + i + xmlSubPrefix3 + this.processTime(startTime) + xmlSubPrefix4 + this.processTime(endTime) + 
                        xmlSubPrefix5 + i + xmlSubPrefix6 + text + xmlSubPrefix7 + this.encodeContent(text) + xmlSubPrefix8;
      xmlContent = xmlContent + xmlSubFinal;
    }

    let xmlPrefix1 = `<?xml version="1.0" encoding="utf-8"?><!DOCTYPE xmeml ><xmeml version="4"><sequence><duration>20852</duration><rate><timebase>25</timebase><ntsc>false</ntsc></rate><name>`;
    let xmlPrefix2 =`</name><media><video><format><samplecharacteristics><rate><timebase>25</timebase><ntsc>false</ntsc></rate><width>1920</width><height>1080</height><anamorphic>false</anamorphic><pixelaspectratio>square</pixelaspectratio><fielddominance>none</fielddominance><colordepth>24</colordepth></samplecharacteristics></format><track>`;
    let xmlPrefix3 = `</track></video></media></sequence><marker></marker></xmeml>`;
    let finalXML = xmlPrefix1 + filename + xmlPrefix2 + xmlContent + xmlPrefix3;
    return finalXML.replace('\t','');
  }

  constructor(props) {
    super(props);
    this.state = {name: "none", status: true, loading: true};
    this.uploadFile = this.uploadFile.bind(this);
    this.clearAll = this.clearAll.bind(this);
  }

  changeTitle = (e) =>{
      let result = this.convertSRTtoXML('awdawd.srt',e.target.value);
      this.setState({xml: result});
  }

  sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  uploadFile(event) {
    const fileReader = new FileReader();
    fileReader.readAsText(event.target.files[0]);
    fileReader.onload = e => {
      let result = this.convertSRTtoXML(event.target.files[0].name, e.target.result);
      this.setState({xml: result});
      this.setState({name: event.target.files[0].name.replace('.srt','')});
      this.setState({loading: false});
      setTimeout(() => {
        this.setState({loading: true});
        this.setState({status: false});
      }, 2000);
      event.target.value = null;
    };
  }

  clearAll(){
    this.setState({loading: true});
    this.setState({status: true});
  }

  downloadTxtFile = () => {
    let element = document.createElement("a");
    const file = new Blob([this.state.xml], {type: 'text/xml'});
    element.href = URL.createObjectURL(file);
    element.download = this.state.name + '.xml';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  render() {
    return (
      <div className="App">
        {/*
        <p className="App-intro">
          Type here to change name.<br/>
        </p><input type="file" name="myFile" onChange={this.uploadFile} />
        <textarea name="description" onChange={this.changeTitle} rows="40" cols="100"/>
        <button onClick={this.downloadTxtFile}>Download txt</button>
        <textarea name="description" value={this.state.xml} rows="40" cols="100"/>
        */}

        <div className="acss-header">
          <div className="acss_banner"></div>
          <div className="verify-form">
            <form className="clearfix">
                <div className="avatar">
                  <div className="theme-share-head">
                    <span className="radius-3">
                      <img src="https://srt2prxml.chdo.xyz/title.png" width="370" />
                      <span className="cert-info"></span>
                    </span>
                  </div>
              </div>
              <div className="verify-input">
                <p>
                    <label className="a_demo_three" href="#">
                      <a>Upload SRT file</a>
                      <input type="file" name="myFile" onChange={this.uploadFile} onClick={this.clearAll} accept=".srt" />
                    </label></p>
                    <br />
                    <div hidden={this.state.loading}>
                    <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                    <p hidden={this.state.status}>
                    <a>{this.state.name}.xml</a>
                    <br/>
                    <br/>
                    <a className="b_demo_three" onClick={this.downloadTxtFile}>Download XML</a>
                    </p>
                    
              </div>
              * The tool is supporting English subtitles only *
              <br />If you feel this tool is helpful, you can <a href="https://buy.stripe.com/bIY4iTcUu59hf4scMM">donate</a> to the author.
            </form>
          </div>
        </div>

        <div className="cloud-bg">
            <div className="bg1"></div>
            <div className="bg2"></div>
            <div className="bg3"></div>
        </div>
      </div>
    );
  }
}